import { render, staticRenderFns } from "./LastQuestion.vue?vue&type=template&id=58ffa3eb&"
import script from "./LastQuestion.vue?vue&type=script&lang=ts&"
export * from "./LastQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports